import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';
import { observer } from 'mobx-react-lite';

import BookOpen from '../../../assets/icons/iconBook.svg';
import EyeClose from '../../../assets/icons/iconEyeClose.svg';
import EyeOpen from '../../../assets/icons/iconEyeOpen.svg';
import PreviewTextArea from './PreviewTextArea';
import MicIndicator from '../speech/MicIndicator';
import { useStoreByName } from '../../../hooks/use-stores.hooks';

interface PreviewModeContainerProps {
  showPreviewContent: boolean;
  onStartReading: (mode: 'reading' | 'byHeart') => void;
}

/**
 * רכיב תצוגה מקדימה עם אפשרויות התחלת קריאה או שינון בעל פה
 * @param showPreviewContent - האם להציג את התוכן עם אנימציה
 * @param onStartReading - פונקציה שמופעלת כשלוחצים על כפתור התחלת קריאה/שינון
 */
const PreviewModeContainer: React.FC<PreviewModeContainerProps> = observer(({ showPreviewContent, onStartReading }) => {
  const { t } = useTranslation();
  const { showByHeartOption } = useStoreByName('uiStore');

  return (
    <div className={`preview-mode container ${showPreviewContent ? 'fade-in' : 'fade-out'}`}>
      <div className="card-header head-line">
        <div className="column">
          <img width="40" height="40" src={BookOpen} alt="ספר פתוח" />
          <h3>{t('preview')}</h3>
        </div>
      </div>
      <div className="content">
        <PreviewTextArea />
        {/* The microphone light sits on the start button it belongs to: in the
            card's yellow header it was yellow on yellow, and only the white
            microphone showed. */}
        <div className="buttons">
          <Button
            variant="contained"
            size="large"
            data-tour="mode-written"
            startIcon={<img width="54" height="54" src={EyeOpen} alt="עין פתוחה" />}
            onClick={() => onStartReading('reading')}
          >
            {t('startReadingPractice')}
            <span className="preview-mic-badge"><MicIndicator /></span>
          </Button>
          {showByHeartOption && (
            <Button
              variant="contained"
              size="large"
              data-tour="mode-byHeart"
              startIcon={<img src={EyeClose} alt="עין סגורה" />}
              onClick={() => onStartReading('byHeart')}
            >
              {t('startMemorizationPractice')}
              <span className="preview-mic-badge"><MicIndicator /></span>
            </Button>
          )}
        </div>
      </div>
    </div>
  );
});

export default PreviewModeContainer;
